import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';

export class BitsUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Bits'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: BitsUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): BitsUnitConverter {
    if (!BitsUnitConverter.instance) {
      BitsUnitConverter.instance = new BitsUnitConverter();
    }
    return BitsUnitConverter.instance;
  }

  protected units = [
    'bit (b) - Bits',
    'byte (B) - Bits',
    'kilobit (kb)',
    'megabit (mb)',
    'gigabit (gb)',
    'terabit (tb)',
    'petabit (pb)',
    'exabit (eb)',
  ] as const;

  protected unitToBase = {
    'bit (b) - Bits': 1,
    'byte (B) - Bits': 8,
    'kilobit (kb)': 1_000,
    'megabit (mb)': 1_000_000,
    'gigabit (gb)': 1_000_000_000,
    'terabit (tb)': 1_000_000_000_000,
    'petabit (pb)': 1_000_000_000_000_000,
    'exabit (eb)': 1_000_000_000_000_000_000,
  };
}
